
import request from "@/hooks/useRequest";
import {POSTSIGNOUT}  from "@/helpers/constants/requestApi";
//退出登录
export const postLoginOutFunc = (body) => {
  return request(POSTSIGNOUT, {body});
};